import { Component, OnInit } from "@angular/core";
import {
  DIAS_VIGENCIA_CERTIFICADO_OFERTAS,
  ESTATUS_CARD_DATA,
  FAQ_CARD,
  RESPONSE_TRACKING,
} from "@constants/tramite-pension-constant";
import { IEstadoTramitePensionResponse } from "@interfaces/estado-tramite-pension.response.interface";
import { StorageService } from "@services/storage/storage.service";
import { IFaqItem } from "@shared/common/interfaces/faq-card.interface";
import { IEstatusCardDetail } from "@shared/common/interfaces/status-card.interface";
import { EstadoTramiteStepperService } from "../../services/estado-tramite-stepper.service";
import { ModalController } from "@ionic/angular";
import { ModalDescargaCertificadoOfertasComponent } from "../../components/modal-descarga-certificado-ofertas/modal-descarga-certificado-ofertas.component";
import { CertificadoOfertaService } from "../../services/certificado-oferta.service";

@Component({
  selector: "app-certificado-ofertas",
  templateUrl: "./certificado-ofertas.component.html",
  standalone: false
})
export class CertificadoOfertasComponent implements OnInit {
  titleFaq: string = "";

  statusCardData = ESTATUS_CARD_DATA[2];

  faqCards = [
    {
      id: "faqModalElement",
      data: [] as IFaqItem[], // Datos para el componente
      title: "", // Título para el componente
      subTitle: ""
    },
    {
      id: "faqElement",
      data: [] as IFaqItem[], // Datos para el componente
      title: "", // Título para el componente
      subTitle: ""
    },
  ];
  tieneCertificadoOferta: boolean = false;
  fechaEmision: string = '';
  fechaVencimiento: string = '';
  constructor(
    private readonly tramiteStepper: EstadoTramiteStepperService,
    private readonly storageService: StorageService,
    private readonly modalCtrl: ModalController,
    private readonly certificadoOfertaService: CertificadoOfertaService,

  ) { }

  async ngOnInit() {
    this.tramiteStepper.setStepCurrent(3);
    this.loadData();
    await this.getCertificadoOferta();
    await this.getDataInfoTramite();
  }

  loadData() {
    const faqData = FAQ_CARD[2].questions;

    this.faqCards = faqData.map((question, index) => ({
      id: index === 0 ? "faqModalElement" : "faqElement",
      data: question.items,
      subTitle: index === 0 ? (FAQ_CARD[2].questions[0].subtitle ?? "") : "",
      title: question.title,
    }));
  }
  async getCertificadoOferta() {
    try {
      const responseCertificadoOferta = await this.certificadoOfertaService.getCerfificadoOferta();
      const { fechaEmision, fechaVencimiento, tieneCertificadoOferta } = responseCertificadoOferta;
      if (tieneCertificadoOferta) {
        this.fechaEmision = fechaEmision;
        this.fechaVencimiento = fechaVencimiento;
        this.tieneCertificadoOferta = true;
      } else {
        this.tieneCertificadoOferta = false;
      }

    } catch (error) {
      console.error('Error al obtener el certificado de ofertas:', error);
      this.tieneCertificadoOferta = false;
    }
  }
  async getDataInfoTramite() {
    const responseTracking: IEstadoTramitePensionResponse =
      await this.storageService.get(RESPONSE_TRACKING);

    this.statusCardData.details = this.getDetailsStatusCard();
    this.statusCardData.infoImportant = 'Luego de conocer la información disponible en el Certificado de Ofertas SCOMP'
    this.statusCardData.infoBoxMessage = responseTracking?.data?.resumen ?? '';
  }

  async openModalDescarga() {
    const modal = await this.modalCtrl.create({
      component: ModalDescargaCertificadoOfertasComponent,
      cssClass: "modal-descarga-certificado"
    });
    await modal.present();
  }

  private formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  private getDetailsStatusCard(): IEstatusCardDetail[] {
    if (this.tieneCertificadoOferta) {
      return [
        {
          label: "Fecha de emisión del certificado",
          value: this.formatDate(this.fechaEmision),
          isHeader: false,
        },
        {
          label: "Fecha de vencimiento del certificado",
          value: this.formatDate(this.fechaVencimiento),
          isHeader: false,
        },
        {
          label: "Vigencia del documento",
          value: `${DIAS_VIGENCIA_CERTIFICADO_OFERTAS} días hábiles`,
          isHeader: false,
        }
      ]
    }
    return [
      {
        label: "Vigencia del documento",
        value: `${DIAS_VIGENCIA_CERTIFICADO_OFERTAS} días hábiles`,
        isHeader: false,
      },
      {
        label: "Solicita del Certificado de Ofertas SCOMP mediante",
        value: "Video Atención o Sucursal de AFP Capital",
        isHeader: false,
      },
    ];
  }
}
